import { Link } from 'react-router-dom';
import '../styles/ContactCTA.css';

const ContactCTA = () => {
  return (
    <section className="contact-cta">
      <div className="cta-content">
        <span>Start a conversation</span>
        <h2>Have a Project or Business Process You Want to Improve?</h2>
        <p>Let’s discuss how software, e-commerce, integrations, or automation could move it forward.</p>
        <Link to="/contact" className="cta-button">Discuss Your Project</Link>
      </div>
    </section>
  );
}

export default ContactCTA;
